import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import{API_URL} from './restcall.constants';
import { catchError, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class LoaformService {

  constructor(private http:HttpClient) { 

  
  }

testRestService(inpt:any){
  return this.http.post(`${API_URL}testG`,inpt,{observe:'response'});
  
}

validateLOAService(inpt :any){

  return this.http.post(`${API_URL}validateLOA`,inpt,{observe:'response'});
}

getCaptchaImage(){
  return this.http.post(`${API_URL}getCaptcha`,{observe:'response'});
}

getVersion(){
  return this.http.post(`${API_URL}getversion`,{observe:'response'}).pipe(map(response => response));
}

}
